(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["business-locations"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Initialize intersection observer for animated entry
  const cards = document.querySelectorAll('.location-card');
  const locationSection = document.querySelector('.business-locations-wrapper');
  let hasStartedIndicatorTimeout = false;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Handle card entry animations
        if (entry.target.classList.contains('location-card')) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
        
        // Start the indicator timeout when the section becomes visible
        // but only if we haven't started it yet
        if (entry.target === locationSection && !hasStartedIndicatorTimeout && window.innerWidth <= 768) {
          hasStartedIndicatorTimeout = true;
          
          // Start the timeout to hide the indicator after 3 animation cycles
          setTimeout(function() {
            const indicator = document.querySelector('.swipe-indicator-container');
            if (indicator) {
              indicator.style.opacity = '0';
              indicator.style.transition = 'opacity 0.8s ease';
              setTimeout(() => {
                indicator.style.display = 'none';
              }, 800);
            }
          }, 12000); // 3 cycles of 4 second animations
        }
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
  });
  
  // Observe all cards for animation
  cards.forEach((card, index) => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    card.style.transition = `opacity 0.8s ease ${index * 0.2}s, transform 0.8s ease ${index * 0.2}s`;
    observer.observe(card);
  });
  
  // Also observe the section itself to trigger the indicator timeout
  if (locationSection) {
    observer.observe(locationSection);
  }
  
  // Add smooth hover effects for buttons
  const buttons = document.querySelectorAll('.directions-btn');
  buttons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      const arrow = this.querySelector('svg');
      arrow.style.transform = 'translateX(4px)';
    });
    
    button.addEventListener('mouseleave', function() {
      const arrow = this.querySelector('svg');
      arrow.style.transform = 'translateX(0)';
    });
  });
  
  // Mobile swipe functionality
  if (window.innerWidth <= 768) {
    const locationsGrid = document.querySelector('.business-locations-grid');
    const dots = document.querySelectorAll('.dot');
    
    if (locationsGrid && cards.length > 1) {
      // Only modify the mobile layout if it's not already done by CSS
      if (getComputedStyle(locationsGrid).display !== 'flex') {
        // Convert grid to horizontal scroll
        locationsGrid.style.display = 'flex';
        locationsGrid.style.overflowX = 'auto';
        locationsGrid.style.scrollSnapType = 'x mandatory';
        locationsGrid.style.webkitOverflowScrolling = 'touch';
        locationsGrid.style.scrollBehavior = 'smooth';
        locationsGrid.style.msOverflowStyle = 'none'; // Hide scrollbar in IE and Edge
        locationsGrid.style.scrollbarWidth = 'none'; // Hide scrollbar in Firefox
        
        // Hide scrollbar in Chrome, Safari and Opera
        const style = document.createElement('style');
        style.textContent = '.business-locations-grid::-webkit-scrollbar { display: none; }';
        document.head.appendChild(style);
        
        // Set card styling for horizontal scroll if it's not already set by CSS
        cards.forEach(card => {
          if (getComputedStyle(card).flex !== '0 0 100%') {
            card.style.flex = '0 0 100%';
            card.style.scrollSnapAlign = 'center';
            card.style.marginRight = '20px';
            card.style.width = '100%';
            card.style.maxWidth = 'calc(100vw - 40px)';
          }
        });
        
        // Remove margin from last card
        if (cards.length > 0) {
          cards[cards.length - 1].style.marginRight = '0';
        }
      }
      
      let currentIndex = 0;
      
      // Indicator click handlers
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          currentIndex = index;
          scrollToCard(currentIndex);
        });
      });
      
      // Update indicators on scroll
      locationsGrid.addEventListener('scroll', function() {
        const scrollPosition = locationsGrid.scrollLeft;
        const cardWidth = cards[0].offsetWidth + 20; // Adding margin
        const newIndex = Math.round(scrollPosition / cardWidth);
        
        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < cards.length) {
          updateIndicators(newIndex);
          currentIndex = newIndex;
        }
      });
      
      function scrollToCard(index) {
        const card = cards[index];
        card.scrollIntoView({ behavior: 'smooth', inline: 'center' });
        updateIndicators(index);
      }
      
      function updateIndicators(newIndex) {
        dots.forEach((dot, i) => {
          if (i === newIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.querySelector('.header');
      this.headerWrapper = this.closest('.header-wrapper');
      if (!this.headerWrapper) {
        console.error('StickyHeader: Could not find .header-wrapper');
        return;
      }

      this.stickyType = this.getAttribute('data-sticky-type');
      this.isAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.isOnScrollUpSticky = this.stickyType === 'on-scroll-up';

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.lastScrollTop = this.currentScrollTop;
      this.scrollThreshold = 200;
      this.stickyThreshold = 50;
      this.scrollDeltaThreshold = 5;
      this.isTicking = false;
      this.isMobile = window.innerWidth < 990;

      this.setHeaderHeight();
      this.applyInitialState();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.debounce(this.onResize.bind(this), 150);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      this.predictiveSearch = this.querySelector('predictive-search');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      const wasHidden = this.headerWrapper.classList.contains('shopify-section-header-hidden');
      if(wasHidden) this.headerWrapper.classList.remove('shopify-section-header-hidden');

      document.documentElement.style.setProperty('--header-height', `${this.headerWrapper.offsetHeight}px`);

      if(wasHidden) this.headerWrapper.classList.add('shopify-section-header-hidden');
    }

    applyInitialState() {
       this.isMobile = window.innerWidth < 990;
       this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

       if (this.isMobile) {
           this.headerWrapper.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
           this.headerWrapper.classList.remove('shopify-section-header-hidden');
           this.headerWrapper.style.position = '';
           this.headerWrapper.style.transform = '';
       } else {
           if (this.isAlwaysSticky) {
               this.headerWrapper.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
               this.headerWrapper.classList.remove('shopify-section-header-hidden');
           } else {
               if (this.currentScrollTop > this.scrollThreshold) {
                   this.headerWrapper.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
                   if (this.isOnScrollUpSticky && this.currentScrollTop > this.stickyThreshold) {
                      this.headerWrapper.classList.add('shopify-section-header-hidden');
                   } else {
                      this.headerWrapper.classList.remove('shopify-section-header-hidden');
                   }
               } else {
                   this.reset();
               }
           }
       }
       this.setHeaderHeight();
    }


    onScroll() {
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.isMobile) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (!this.isTicking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          this.isTicking = false;
        });
        this.isTicking = true;
      }
    }

     handleScroll() {
      if (this.isMobile) return;

      const scrollDirection = this.currentScrollTop > this.lastScrollTop ? 'down' : 'up';
      const scrollDelta = Math.abs(this.currentScrollTop - this.lastScrollTop);
      const isPastThreshold = this.currentScrollTop > this.scrollThreshold;
      const isPastStickyThreshold = this.currentScrollTop > this.stickyThreshold;

      if (isPastThreshold) {
        if (!this.headerWrapper.classList.contains('shopify-section-header-sticky')) {
           this.headerWrapper.classList.add('shopify-section-header-sticky');
        }
        if (!this.headerWrapper.classList.contains('scrolled-past-header')) {
          this.headerWrapper.classList.add('scrolled-past-header');
        }
      } else {
        if (!this.isAlwaysSticky) {
           this.reset();
        }
      }

      if (this.isOnScrollUpSticky && isPastThreshold) {
        if (scrollDirection === 'down' && isPastStickyThreshold && scrollDelta >= this.scrollDeltaThreshold) {
          this.hide();
        }
        else if (scrollDirection === 'up' && scrollDelta >= this.scrollDeltaThreshold) {
          this.reveal();
        }
      }
      else if (this.isOnScrollUpSticky && scrollDirection === 'up' && isPastThreshold) {
          this.reveal();
      }


      this.lastScrollTop = this.currentScrollTop <= 0 ? 0 : this.currentScrollTop;
    }

    hide() {
      if (this.isOnScrollUpSticky && !this.headerWrapper.classList.contains('shopify-section-header-hidden')) {
          this.headerWrapper.classList.add('shopify-section-header-hidden');
          this.closeMenuDisclosure();
          this.closeSearchModal();
      }
    }

    reveal() {
       if (this.headerWrapper.classList.contains('shopify-section-header-hidden') || this.isAlwaysSticky) {
           this.headerWrapper.classList.remove('shopify-section-header-hidden');
       }
    }

    reset() {
       if (!this.isAlwaysSticky) {
           this.headerWrapper.classList.remove(
               'shopify-section-header-hidden',
               'shopify-section-header-sticky',
               'scrolled-past-header'
           );
           this.headerWrapper.style.position = '';
           this.headerWrapper.style.transform = '';
       }
    }

    closeMenuDisclosure() {
      const disclosures = this.headerWrapper.querySelectorAll('details-disclosure, header-menu, details');
      disclosures.forEach(disclosure => {
          if (disclosure.tagName === 'DETAILS' && disclosure.hasAttribute('open')) {
               disclosure.removeAttribute('open');
          } else if (typeof disclosure.close === 'function') {
              disclosure.close();
          }
      });
    }

    closeSearchModal() {
      const searchModal = this.headerWrapper.querySelector('details-modal');
       if (searchModal && searchModal.tagName === 'DETAILS' && searchModal.hasAttribute('open')) {
           searchModal.removeAttribute('open');
       } else if (searchModal && typeof searchModal.close === 'function') {
          searchModal.close(false);
      }
    }

    onResize() {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 990;
        if (wasMobile !== this.isMobile) {
            this.applyInitialState();
        } else {
            this.setHeaderHeight();
        }
    }

    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func.apply(this, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function setMobileVhProperty() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--mobile-vh', `${vh}px`);
  }
  setMobileVhProperty();
  let vhResizeTimer;
  window.addEventListener('resize', () => {
      clearTimeout(vhResizeTimer);
      vhResizeTimer = setTimeout(setMobileVhProperty, 150);
  });
  window.addEventListener('orientationchange', setMobileVhProperty);


  } catch(e) { console.error(e); }
})();
})();
